import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IServerSettings, IServiceError } from '../models/index';
import { AuthenticationService } from './authentication.service';
import { SettingsService } from './settings.service';
import { HttpHelper } from '../helpers/http-helper';
import { StorageManagerService } from './storage-manager.service';
import { IFileIngestionHistory } from '../models/file-upload-history.model';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';


@Injectable()
export class FileUploadService extends Subject<DataStateChangeEventArgs>  {

  private action: string;
  private apiGatewayUrl: string;
  private settings: IServerSettings;
  httpHelper: HttpHelper;

  constructor (private http: HttpClient, private settingsService: SettingsService, private authService: AuthenticationService, private storageManagerService: StorageManagerService) {
    super();
    this.httpHelper = new HttpHelper(http, authService, storageManagerService);
  }

  fetchUploadedFileHistory(dateRangeLimit: string): Observable<IFileIngestionHistory[]>  {
    this.settings = this.settingsService.getSettings();
    this.apiGatewayUrl = this.settings.ApiGatewayUrl;
    this.action = `ssdpds/v1/SplUpload/History`;

    const headers = this.httpHelper.createHttpHeaders();

    return this.http.get(`${ this.apiGatewayUrl }/${ this.action }?dateRangeLimit=${ dateRangeLimit }`, { headers: headers })
    .pipe(map(this.extractData),
    catchError(this.handleErrors));
  }

  downloadUploadedFileHistoryLog(fileId:number, reportFilename: string): Observable<IFileIngestionHistory[]>  {
    this.settings = this.settingsService.getSettings();
    this.apiGatewayUrl = this.settings.ApiGatewayUrl;
    this.action = `ssdpds/v1/SplUpload/ImportLog`;

    const headers = this.httpHelper.createHttpHeaders();

    return this.http.get(`${ this.apiGatewayUrl }/${ this.action }?fileId=${ fileId }&reportFilename=${reportFilename}`, { headers: headers, responseType: 'blob' })
    .pipe(map(response => response),
    catchError(this.handleErrors));
  }

  // Get data successfully from api call
  private extractData(response: Response) {
    if (response.status < 200 || response.status >= 300) {
        throw new Error('Bad response status: ' + response.status);
    }

    const body = response;
    return body || {};
  }

  private handleErrors(error: any): Observable<any> {
    const GENERIC_ERROR_MSG = 'It looks like something went wrong. Try reloading the page or contacting support if this issue continues.';
    const bDisplayDetailMsg = error && error.error && error.error.isBusinessErrorMessage ? true : isDevMode() ? true : false;
    error.error = error && error.error && error.error.message && bDisplayDetailMsg ? error.error.message : GENERIC_ERROR_MSG;

    return throwError(error.error);
  }
}
